export default "__VITE_ASSET__B4es3Ohp__"